<div class="modal-container">
    <div class="modal-content">
        <div class="modal-header">
            <h1>Add Requirements</h1>
            <mat-form-field floatLabel="never" appearance="fill">
                <mat-icon aria-hidden="false" aria-label="search icon" matSuffix>
                    search
                </mat-icon>
                <input matInput placeholder="Search" [(ngModel)]="searchText">
            </mat-form-field>
        </div>
        <div class="case-requirements">
            <form [formGroup]="caseRequirementForm" (ngSubmit)="saveAndClose()">
                <div formArrayName="caseRequirements">
                    <div *ngFor="let req of filteredCaseRequirements; let i = index" [formGroup]="req">
                        <div class="case-requirement-item-container">
                            <div style="width: 60%;">
                                <mat-checkbox formControlName="isSelected">
                                </mat-checkbox>
                                <span>{{ req.get('name')?.value }}</span>
                            </div>
                            <div style="width: 40%;">
                                <mat-form-field [hidden]="!req.get('isSelected')?.value || req.disabled" style="width: 100%;">
                                    <mat-label>Optional Subtitle</mat-label>
                                    <input matInput formControlName="subtitle" [attr.maxlength]="characterLimit">
                                    <mat-hint *ngIf="req?.get('subtitle').valid">
                                        {{(characterLimit - req?.get('subtitle').value.length) < 0 ? 0 : characterLimit
                                            - req?.get('subtitle').value.length}}/{{characterLimit}} characters
                                            remaining </mat-hint>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div class="close-box">
        <button class="cancel-btn" type="button" mat-button color="primary" class="material-default" (click)="cancel()">
            CANCEL
        </button>
        <button class="save-close-btn" type="button" mat-button color="primary" class="material-default"
            (click)="saveAndClose()">
            SAVE AND CLOSE
        </button>
    </div>
</div>